import React from 'react';
import { motion } from 'framer-motion';
import DonateBtn from './DonateBtn';

export default function ChildCard({ child }) {
  // We use split(' ')[0] to just get the first name for the button text
  const firstName = child.name ? child.name.split(' ')[0].toUpperCase() : 'NOW';

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="group relative bg-slate-900 rounded-3xl overflow-hidden border border-white/10 shadow-2xl transition-all duration-500 hover:border-gh-orange/50"
    >
      {/* Image Container */}
      <div className="relative h-96 overflow-hidden">
        <img 
          src={`/profiles/profile${child.id}.jpg`} 
          alt={`Profile of ${child.name || 'Child'}`}
          className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-1000 group-hover:scale-105"
          /* object-top ensures the head/top of the photo is prioritized */
          onError={(e) => { e.target.src = "https://via.placeholder.com/400x600?text=Profile+Coming+Soon"; }}
        />
        
        {/* Gradient Overlay & Story */}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/40 to-transparent flex flex-col justify-end p-6">
          <div className="bg-black/60 backdrop-blur-md p-4 rounded-2xl border border-white/10 transform translate-y-8 group-hover:translate-y-0 transition-all duration-500 opacity-0 group-hover:opacity-100">
             <p className="text-white text-xs leading-relaxed font-medium italic">
              "{child.story}"
            </p>
          </div>
        </div>
      </div>

      {/* Info Area */}
      <div className="p-6">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h4 className="text-xl font-bold text-white tracking-tight leading-tight">
              {child.name || "Awaiting Name"}
            </h4>
            <div className="flex items-center gap-2 mt-2">
              <p className="text-gh-orange text-[10px] font-black tracking-[0.2em] uppercase">
                {child.age ? `${child.age} Years` : "Age TBD"}
              </p>
              <span className="text-white/20 text-xs">•</span>
              <p className="text-slate-400 text-[10px] font-bold uppercase tracking-[0.1em]">
                {child.classLevel || "Class TBD"}
              </p>
            </div>
          </div>
          <div className="bg-white/5 px-2 py-1 rounded-lg border border-white/10 shrink-0">
             <span className="text-[9px] text-slate-500 font-bold uppercase tracking-tighter">REF: GH-{child.id}</span>
          </div>
        </div>
        
        <DonateBtn 
          label={`SPONSOR ${firstName}`} 
          className="w-full !py-4 !text-xs !rounded-xl !bg-gh-orange hover:!bg-orange-600 shadow-lg !font-black !tracking-[0.2em] transition-all hover:scale-[1.02] uppercase" 
        />
      </div>
    </motion.div>
  );
}